$(document).ready(function() {
    // Show the popup when the "Ukážka emailom" button is clicked
    $("#showPreviewPopup").on("click", function() {
        showPreviewForm();
    });

    // Function to show the main form
    function showPreviewForm() {
        // Hide all popups first
        $("#previewSuccessPopup, #previewErrorPopup").hide();
        // Show the main form
        $("#previewMainPopup").show();
        // Show the popup wrapper
        $("#productPreviewPopup").fadeIn();
    }

    // Function to show success popup
    function showSuccessPopup() {
        $("#previewMainPopup, #previewErrorPopup").hide();
        $("#previewSuccessPopup").show();
    }

    // Function to show error popup
    function showErrorPopup() {
        $("#previewMainPopup, #previewSuccessPopup").hide();
        $("#previewErrorPopup").show();
    }

    // Close buttons for all popups
    $("#closePreviewPopup, #closeSuccessPopup, #closeErrorPopup").on("click", function() {
        clearFormErrors();
        resetForm();
        $("#productPreviewPopup").fadeOut();
    });

    // Function to clear all form errors
    function clearFormErrors() {
        $("#emailError").hide();
        $("#preview-form-email-label").removeClass("form-label-error");
        $("#approvalLabel").removeClass("form-label-error");
    }

    // Function to reset form fields
    function resetForm() {
        $("#email").val('');
        $("#approvalCheckbox").prop('checked', false);
    }

    // Handle form submission
    $("#sendPreviewButton").on("click", function() {
        var email = $("#email").val();
        var approval = $("#approvalCheckbox").is(":checked");
        var emailError = $("#emailError");

        // Clear previous errors
        clearFormErrors();

        let hasError = false;

        // Basic validation for email
        if (!email) {
            emailError.text("Prosím zadajte emailovú adresu").show();
            $("#preview-form-email-label").addClass("form-label-error");
            hasError = true;
        } else {
            // Simple regex to validate email
            var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            if (!emailRegex.test(email)) {
                emailError.text("Prosím zadajte platnú emailovú adresu").show();
                $("#preview-form-email-label").addClass("form-label-error");
                hasError = true;
            }
        }

        // Validation for approval checkbox
        if (!approval) {
            $("#approvalLabel").addClass("form-label-error");
            hasError = true;
        }

        // If any validation failed, don't proceed
        if (hasError) {
            return;
        }

        // For testing - always show success popup
        // showSuccessPopup();

        // When ready for production, uncomment this code and remove the line above
        var productId = $("#product-detail").data("product-id");
        $.ajax({
            url: '/api/shop/send-preview/' + productId,  // Your API endpoint
            method: 'POST',
            data: {
                email: email,
                approval: approval
            },
            success: function(response) {
                resetForm();
                showSuccessPopup();
            },
            error: function(xhr, status, error) {
                showErrorPopup();
            }
        });
    });
});
